import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';

import { Tag } from 'src/graphql/generated/graphql';

export const getFilterConfig = ({ t, tags }: { t: TFunction; tags: Tag[] }) => [
  {
    id: 'tagIds',
    size: 2,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('common.tags'),
        variant: 'outlined',
        name: 'tagIds',
        label: t('common.tags'),
      },
      options: tags.map((tag) => ({
        value: tag.id,
        name: tag.name,
      })),
    },
  },
];
